// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-3ff9bb6e]{vertical-align:middle!important;text-align:center;width:24px!important;margin-right:5px}.menuItem[data-v-3ff9bb6e]{width:100%}.menuItem[data-v-3ff9bb6e],.menuNum[data-v-3ff9bb6e]{display:inline-block}.menuNum[data-v-3ff9bb6e]{margin-left:30px;width:24px;height:24px;line-height:24px;border-radius:15px;color:#fff;text-align:center;align-items:center;justify-content:center;font-size:13px;background-color:red}", ""]);
// Exports
module.exports = exports;
